import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import StrategicCounselForModernEnterprise from "./sections/StrategicCounselForModernEnterprise";
import OurAdvancedTechnicalSolutions from "./sections/OurAdvancedTechnicalSolutions";
import ScheduleACollection from "./sections/ScheduleACollection";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <StrategicCounselForModernEnterprise />
      <OurAdvancedTechnicalSolutions />
      <ScheduleACollection />
      <Footer />
    </div>;
}